/** @format */
import {SyntheticEvent} from 'react';

import {styled, useTheme} from '@mui/material/styles';

import {Box, useMediaQuery} from '@mui/material';
import {ErrorOutline} from '@mui/icons-material';

import {PlatformWithAll as Platform} from 'types';

import StyledTab from './StyledTab';
import StyledTabs from './StyledTabs';

const PREFIX = 'NativeTabs';

const classes = {
  labelContainer: `${PREFIX}-labelContainer`,
  icon: `${PREFIX}-icon`,
};

const StyledStyledTabs = styled(StyledTabs)(({theme}) => ({
  [`& .${classes.labelContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },

  [`& .${classes.icon}`]: {
    width: 16,
    height: 16,
    color: '#CE5959',
  },
}));

interface Props {
  onChange: (value: Platform) => void;
  activeTabName?: Platform | string;
  tabs: {
    name: string;
    text: string;
    mobileText?: string;
    hasWarning?: boolean;
  }[];
  variant: string;
}

const NativeTabs = (props: Props) => {
  const handleChange = (_: SyntheticEvent<Element, Event>, value: Platform) => {
    props.onChange(value);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledStyledTabs value={props.activeTabName} onChange={handleChange}>
      {props.tabs.map((v, i) => {
        const label = isMobile ? v.mobileText : v.text;

        return (
          <StyledTab
            key={i}
            label={
              v.hasWarning ? (
                <Box component='span' className={classes.labelContainer}>
                  {label} <ErrorOutline className={classes.icon} />
                </Box>
              ) : (
                label
              )
            }
            value={v.name}
            variant={props.variant}
          />
        );
      })}
    </StyledStyledTabs>
  );
};

export default NativeTabs;
